import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import './ShowcaseModeChrome.css';

export function ShowcaseModeLoader() {
  return (
    <Box className="ps-showcase-loader" role="status" aria-live="polite" aria-label="Opening Showcase mode">
      <Box className="ps-showcase-loader__scene">
        <Box className="ps-showcase-loader__word" aria-hidden="true">
          {'SHOWCASE'.split('').map((letter, index) => (
            <span key={`${letter}-${index}`} style={{ '--ps-letter-index': index }}>{letter}</span>
          ))}
        </Box>
        <Typography className="ps-showcase-loader__caption">Preparing your storefront workspace</Typography>
        <Box className="ps-showcase-loader__track" aria-hidden="true">
          <Box className="ps-showcase-loader__beam" />
        </Box>
        <Box className="ps-showcase-loader__dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </Box>
      </Box>
    </Box>
  );
}

export function ShowcaseModeExit({ onExit }) {
  return (
    <Box className="ps-showcase-exit-zone">
      <Box className="ps-showcase-exit-control">
        <Typography variant="caption">Exit Showcase</Typography>
        <Tooltip title="Exit Showcase mode" placement="left">
          <IconButton
            size="small"
            className="ps-showcase-exit-button"
            onClick={onExit}
            aria-label="Exit Showcase mode"
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

export default function ShowcaseModeChrome({ active, booting, onExit }) {
  if (!active) return null;
  return (
    <>
      {booting ? <ShowcaseModeLoader /> : null}
      {!booting ? <ShowcaseModeExit onExit={onExit} /> : null}
    </>
  );
}
